export default __webpack_public_path__ + "static/media/stetho.c7b024fe.svg";